<div>
  <br />
  <div class="search-row-1">
    <form
      #CommissionForm="ngForm"
      [formGroup]="commissionForm"
      class="form-container"
      style="width: 900px"
    >
      <mat-form-field appearance="outline" class="fieldSize1">
        <mat-select
          placeholder="Term *"
          [(ngModel)]="selectedTermOption"
          formControlName="termCtrl"
          (selectionChange)="optionChanged2()"
        >
          <mat-option *ngFor="let term of termList" [value]="term.Name">
            {{ term.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <div>
    <div class="lineContainer">
      <div class="buttonVAligned">
        <div class="AgencyInfo">
          <span class="label">
            <label>Agency ID:</label>
          </span>
          <span>
            {{ this.agencyID }}
          </span>
          <br />
          <span class="label">
            <label>Agency Name:</label>
          </span>
          <span>
            {{ this.agencyName }}
          </span>
        </div>
      </div>
      <div class="search-bar" id="applications-search">
        <mat-form-field id="dropDownAgentsList" appearance="outline">
          <mat-label>Select All Agents</mat-label>
          <mat-select
            [(value)]="selectedAgentOption"
            (selectionChange)="optionChanged()"
          >
            <mat-option [value]="0" (click)="applyFilter('0')"
              >All Agents</mat-option
            >
            <mat-option
              *ngFor="let optionSel of agentsList"
              [value]="optionSel.Agent_Name"
            >
              {{ optionSel.Agent_Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div id="spacer">
          <span> </span>
        </div>

        <mat-form-field appearance="outline" class="search-bar">
          <mat-label>Search list</mat-label>
          <input
            type="text"
            matInput
            #search
            (keyup)="applyFilter($event.target.value)"
            maxlength="256"
            placeholder="Search"
          />
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint>Example: Student #, Name</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="rowExport">
    <div class="alignToRight">
      <span>
        <a (click)="ExportToExcel()"
          >Export to XLS
          <span>
            <img src="../../../../../../assets/img/export-excel-48-3.png" />
          </span>
        </a>
      </span>
      <span id="spacer"> </span>
      <span>
        <a (click)="ExportToPDF()" class="Seneca-Export-Button"
          >Export to PDF
          <span>
            <img src="../../../../../../assets/img/export-pdf-48-3.png" />
          </span>
        </a>
      </span>
    </div>

    <div class="table-form">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="mat-elevation-z8"
        matSortActive="SubmittedDate"
        matSortDirection="desc"
        multiTemplateDataRows
        (matSortChange)="sortData($event)"
      >
        <ng-container matColumnDef="Term">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Term</th>
          <td mat-cell *matCellDef="let element">{{ element.Term }}</td>
        </ng-container>

        <ng-container matColumnDef="StudentName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Student Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.StudentName }}</td>
        </ng-container>

        <ng-container matColumnDef="SENECA_ID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Student Number
          </th>
          <td mat-cell *matCellDef="let element">{{ element.SENECA_ID }}</td>
        </ng-container>

        <ng-container matColumnDef="ProgramDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Program Name
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.ProgramDescription }}
          </td>
        </ng-container>

        <ng-container matColumnDef="SubmittedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Submitted Date
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.SubmittedDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="AgentName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Agent Name</th>
          <td mat-cell *matCellDef="let element">{{ element.AgentName }}</td>
        </ng-container>

        <ng-container matColumnDef="AgentDispute">
          <th mat-header-cell *matHeaderCellDef mmat-sort-header>
            Agent Dispute
          </th>
          <td mat-cell *matCellDef="let element">
            <span
              class="material-icons-centered"
              (click)="onDispute(element.ApplicationID, element.RequestTypeID, element.Term)"
            >
              <mat-icon class="agentDispute" matSuffix>sms_failed</mat-icon>
            </span>
          </td>
        </ng-container>
        <!--
        <ng-container matColumnDef="Payment_Description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Type</th>
          <td mat-cell *matCellDef="let element">{{element.Payment_Description}}</td>
        </ng-container>
-->
        <ng-container matColumnDef="CommissionAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Commission Amount
          </th>
          <td mat-cell *matCellDef="let element">
            $ CAD {{ element.CommissionAmount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="CommissionStatusName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Commission Status
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.CommissionStatusName }}
            <div *ngIf="!element.CommissionStatusName">N/A</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="requestStatusName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Request Status
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.requestStatusName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="VoucherNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Invoice
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.VoucherNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div
              class="application-element-detail"
              [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'"
            >
              <span class="mat-column-select"></span>
              <span mat-subheader
                >{{ element.ProgramDescription }}, {{ element.ProgramCampus }},
                {{ element.CountryName }}</span
              >
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row"
          (click)="viewDetail(row)"
        ></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
